// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-viewer {
  display: block;
  width: 100%;
  height: 100%;
}

.alert {
  padding-left: 0px;
}

.my_class1 {
  pointer-events: none;
  color: dimgrey;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbnRyYWN0LXZpZXcuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxjQUFBO0VBQ0EsV0FBQTtFQUNBLFlBQUE7QUFDRjs7QUFFQTtFQUNFLGlCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxvQkFBQTtFQUNBLGNBQUE7QUFDRiIsImZpbGUiOiJjb250cmFjdC12aWV3LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnBkZi12aWV3ZXIge1xuICBkaXNwbGF5OiBibG9jaztcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTtcbn1cblxuLmFsZXJ0IHtcbiAgcGFkZGluZy1sZWZ0OiAwcHg7XG59XG5cbi5teV9jbGFzczEge1xuICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgY29sb3I6IGRpbWdyZXk7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/contracts/contract-view/contract-view.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,oBAAA;EACA,cAAA;AACF;AACA,glBAAglB","sourcesContent":[".pdf-viewer {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.alert {\n  padding-left: 0px;\n}\n\n.my_class1 {\n  pointer-events: none;\n  color: dimgrey;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
